// eslint-disable-next-line import/prefer-default-export
export const RESET_STORE = 'RESET_STORE'

export interface IResetStore {
	type: typeof RESET_STORE
}
